import * as React from 'react';
import { ReactNode } from 'react';

import styled from 'styled-components';

import { mq } from 'components/constants/breakpoints';

export interface IMenuItemListProps {
  children: ReactNode[];
}

export const MenuItemList = ({ children }: IMenuItemListProps) => (
  <MenuGroup>{children}</MenuGroup>
);

/**
 * `-6px` — ровно поле ссылки пункта (`MenuItem`): первая подпись стоит по краю
 * содержимого. `min-width: 0` + `flex: 1 1 auto` — меню занимает место между
 * краем и правой группой шапки и может ужиматься.
 */
const MenuGroup = styled.div`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 0 -6px;

  /* ТЗ 0121: на планшете (768–1279) шесть групп в строку не помещаются —
     переносим их, а не налезаем на правую группу шапки. */
  ${mq.tablet} {
    flex-wrap: wrap;
    row-gap: 4px;
  }
`;
